export class EquipmentRequest {
    id!: string
    rentalType!: number
    equipment!: string
    category!: string
    requestedById!: string
    requestedByHrRef!: number
    forJob!: string
    fromJob!: string
    dateNeeded!: Date
    notes!: string
    billingCycle!: number
    serialNum!: string
    imageUrls!: string[]
}
